const STRING_CAMELIZE_REGEXP_1 = /(\-|\_|\.|\s)+(.)?/g;
const STRING_CAMELIZE_REGEXP_2 = /(^|\/)([A-Z])/g;

export const camelize = key => key
    .replace(STRING_CAMELIZE_REGEXP_1, (_match, _separator, chr) => (chr ? chr.toUpperCase() : ''))
    .replace(STRING_CAMELIZE_REGEXP_2, (match) => match.toLowerCase())

export default function transformKeys(value, transform) {

    if (value == null) {
        return value;
    } else if (Array.isArray(value)) {
        return value.map(item => transformKeys(item, transform));
    } else if (typeof value === 'object') {
        let result = {};

        Object.keys(value).forEach(key => {
            result[transform(key)] = transformKeys(value[key], transform);
        });

        return result;
    } else {
        return value;
    }
}

export const camelizeKeys = str => transformKeys(str, camelize);
